import { HTTP_CODE } from '@/utils/request'
import * as service from './service'
import Toast from 'antd-mobile/es/toast'
export default {
  namespace: 'propBackhaulSetting',
  state: {
    demoData: {}
  },
  effects: {
    * getUsePropTips ({ payload }, { call, put }) {
      const res = yield call(service.usePropTips, payload)
      if (res.status !== HTTP_CODE.success) {
        // Toast.fail(res.data.err)
        console.error(res.data.err)
      }
      return res.data
    },
    * selectArea ({ payload }, { call, put }) {
      const res = yield call(service.selectArea, payload)
      if (res.status !== HTTP_CODE.success) {
        // Toast.fail(res.data.err)
        console.error(res.data.err)
      }
      return res.data
    },
    * submit ({ payload, bizCodeHandler, bizCodes }, { call, put }) {
      try {
        const res = yield call(service.submit, payload, bizCodeHandler, bizCodes)
        if (res.data.status !== HTTP_CODE.success) {
          // Toast.fail(res.data.err)
          console.error(res.data.err)
        }
        return res.data
      } catch (err) {
        console.log(err, 'errrrrrr')
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
